import { render, staticRenderFns } from "./AdminOpportunity.vue?vue&type=template&id=1501ad8e"
import script from "./AdminOpportunity.vue?vue&type=script&lang=js"
export * from "./AdminOpportunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports